import { Component } from '@angular/core';

import type { User } from '@recruitee/account-types';
import {
  AdminsAvatarsComponent,
  DialogBodyComponent,
  DialogComponentI,
  HeadingComponent,
} from '@recruitee/user-interface';

interface NoAccessDialogData {
  title: string;
  description: string;
  imageSrc: string;
  admins: User[];
}

@Component({
  standalone: true,
  imports: [AdminsAvatarsComponent, DialogBodyComponent, HeadingComponent],
  selector: 'rt-no-access-dialog',
  templateUrl: './no-access-dialog.component.html',
  styleUrls: ['./no-access-dialog.component.less'],
})
export class NoAccessDialogComponent implements DialogComponentI<NoAccessDialogData, null> {
  public readonly ADMINS_LIMIT = 3;
  public title: string;
  public description: string;
  public admins: User[] = [];
  public imageSrc: string;

  public setDialogData(data: NoAccessDialogData, triggerUpdate: boolean): void {
    this.title = data.title;
    this.description = data.description;
    this.imageSrc = data.imageSrc;
    this.admins = data.admins;
  }
}
